<template>
    <div class="col-md-12 quote-history">
        <div id="sending" v-if="formState == 'sending' || loading">
            <div class="overlay"></div>
            <div class="form-sending"></div>
        </div>
        <div class="row mt-md-2 mt-3" v-for="entry in history" :key="entry.id">
            <div class="col-md-9 message from-client" v-if="entry.senderType.slug == 'client'">
                <div class="row align-self-start">
                    <div class="col-md-2 quote_message__section">
                        <span class="client__name">
                            {{ entry.clientContact.name }}
                        </span>
                        {{entry.added.locale.date}}
                    </div>
                    <div class="col-md-9 quote_message__section align-self-center">
                        <div class="row">
                            <div class="col-md-12">
                                <span class="status" :class="entry.status.code">Tila: {{entry.status.locale.name}}</span>
                            </div>
                        </div>
                        <transition-collapse-height>
                            <div class="row collapsible-message" v-if="isMessageVisible(entry.id)">
                                <div class="col-md-12">
                                    {{ entry.message }}
                                </div>
                            </div>
                        </transition-collapse-height>
                    </div>
                    <div class="col-md-1 history-toggle quote_message__section align-self-center" :key="rerenderToggles">
                        <transition name="fade">
                            <a @click="closeMessage(entry.id)" v-if="isMessageVisible(entry.id)">
                                <i class="fas fa-arrow-alt-circle-up arrow-icon--client arrow-icon"></i>
                            </a>
                            <a @click="openMessage(entry.id)" v-else>
                                <i class="fas fa-arrow-alt-circle-down arrow-icon--client arrow-icon"></i>
                            </a>
                        </transition>
                    </div>
                </div>
            </div>
            <div class="col-md-2" v-if="entry.senderType.slug == 'client'"></div>
            <div class="col-md-2" v-if="entry.senderType.slug == 'user'"></div>
            <div class="col-md-2" v-if="entry.senderType.slug == 'system'"></div>
            <div class="col-md-9 message from-band" v-if="entry.senderType.slug == 'user'">
                <div class="row align-self-start">
                    <div class="col-md-1 history-toggle order-3 order-md-1 quote_message__section align-self-center" :key="rerenderToggles">
                        <transition name="fade">
                            <a @click="closeMessage(entry.id)" v-if="isMessageVisible(entry.id)">
                                <i class="fas arrow-icon arrow-icon--band fa-arrow-alt-circle-up"></i>
                            </a>
                            <a @click="openMessage(entry.id)" v-else>
                                <i class="fas arrow-icon arrow-icon--band fa-arrow-alt-circle-down"></i>
                            </a>
                        </transition>
                    </div>
                    <div class="col-md-9 order-2 order-md-2 quote_message__section align-self-center">
                        <div class="row">
                            <div class="col-md-8">
                                <span class="status" :class="entry.status.code">Tila: {{entry.status.locale.name}}</span>
                            </div>
                        </div>
                        <transition-collapse-height>
                            <div class="row collapsible-message" v-if="isMessageVisible(entry.id)">
                                <div class="col-md-10">
                                    {{ entry.message }}
                                </div>
                            </div>
                        </transition-collapse-height>
                    </div>
                    <div class="col-md-2 order-1 order-md-3 quote_message__section">
                        <span class="client__name">
                            {{ entry.user.givenName }} {{ entry.user.familyName }}
                        </span>
                        {{entry.added.locale.date}}
                    </div>
                </div>
            </div>

            <div class="col-md-9 message from-system" v-if="entry.senderType.slug == 'system'">
                <div class="row align-items-center">
                    <div class="col-md-1 history-toggle order-3 order-md-1 quote_message__section" :key="rerenderToggles">
                        <transition name="fade">
                            <a @click="closeMessage(entry.id)" v-if="isMessageVisible(entry.id)">
                                <i class="fas fa-arrow-alt-circle-up arrow-icon arrow-icon--system"></i>
                            </a>
                            <a @click="openMessage(entry.id)" v-else>
                                <i class="fas fa-arrow-alt-circle-down arrow-icon arrow-icon--system"></i>
                            </a>
                        </transition>
                    </div>
                    <div class="col-md-9 order-2 order-md-2 quote_message__section">
                        <div class="row">
                            <div class="col-md-8">
                                <span class="status" :class="entry.status.code">Tila: {{entry.status.locale.name}}</span>
                            </div>
                        </div>
                        <transition-collapse-height>
                            <div class="row collapsible-message" v-if="isMessageVisible(entry.id)">
                                <div class="col-md-10">
                                    {{ entry.message }}
                                </div>
                            </div>
                        </transition-collapse-height>
                    </div>
                    <div class="col-md-2 order-1 order-md-3 quote_message__section">
                        <span class="client__name">
                            Buukkaa-bandi.fi
                        </span>
                        {{entry.added.locale.date}}
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <hr class="row"/>
            </div>
        </div>
        <div class="row">
            <quote-reply
                v-if="quote != null"
                :id=id
                :checksum=checksum
                :quote=quote
                :history=history
                :turnDownOptions=turnDownOptions
                :has-contract=hasContract
                v-on:formsent="reloadHistory(true)"
            ></quote-reply>
        </div>
    </div>
</template>

<script>
    import ApiCall from '../modules/ApiCall';
    import QuoteReply from './QuoteReply';
    import Routes from '../modules/Routes';
    import TransitionCollapseHeight from './TransitionCollapseHeight';

    export default {
        components: {
            TransitionCollapseHeight,
            QuoteReply
        },
        mounted() {
            this.reloadHistory(true);
            ApiCall.getCached(Routes.generate('_public_api_options_turndown_options', { usedBy: 'client' })).then((response) => {
                this.turnDownOptions = response.options;
            });
        },
        props: {
            id: {
                type: Number
            },
            checksum: {
              type: String
            },
            hasContract: {
              type: Boolean,
              default: false,
            },
        },
        data() {
            return {
                loading: true,
                history: [],
                quote: null,
                toggles: {},
                formVisible: true,
                formState: 'not-sent',
                rerenderToggles: 0,
                turnDownOptions: []
            };
        },
        methods: {
            getFetchUrl() {
                return Routes.generate('_public_api_get_quote_history', { id: this.id, checksum: this.checksum });
            },
            reloadHistory(reset) {
                this.loading = true;
                ApiCall.getData(this.getFetchUrl()).then((response) => {
                    this.history = response.history;
                    this.quote = response.quote;
                    this.loading = false;

                    if (reset) {
                        this.resetToggles(this.history);
                    }
                });
            },
            resetToggles(data) {
                data.forEach((entry, index) => {
                    if (data.length === (index + 1)) {
                        return this.$set(this.toggles, entry.id, true);
                    }

                     return this.$set(this.toggles, entry.id, false);
                });
                this.reRenderToggles();
            },
            isMessageVisible(id) {
                return this.toggles[id];
            },
            openMessage(id) {
                this.reRenderToggles();
                this.$set(this.toggles, id, true);
            },
            closeMessage(id) {
                this.reRenderToggles();
                this.$set(this.toggles, id, false);
            },
            reRenderToggles() {
                this.rerenderToggles += 1;
            }
        }
    };
</script>
